import { Category } from '@modules/common/types';
import { FormatQuoteRounded } from '@mui/icons-material';
import { Alert, Box, Typography } from '@mui/material';
import { Reason } from 'generated/graphql';
import { EditCategoryWidget } from '../EditCategoryWidget';

interface EditReasonCategoryWidgetProps {
  fullWidth?: boolean;
  activeReasonName: Reason['displayName'];
  initialCategory?: Category;
  selectedCategory?: Category;
  updateSelectedCategory: (category: Category) => void;
  iconSize?: number;
}

export const EditReasonCategoryWidget = ({
  fullWidth,
  activeReasonName,
  initialCategory,
  selectedCategory,
  updateSelectedCategory,
  iconSize,
}: EditReasonCategoryWidgetProps) => {
  return (
    <>
      <EditCategoryWidget
        iconSize={iconSize}
        fullWidth={fullWidth}
        selectedCategory={selectedCategory}
        updateSelectedCategory={updateSelectedCategory}
      />
      {initialCategory && initialCategory !== selectedCategory && (
        <Alert
          severity="info"
          sx={{
            mt: 1,
            mb: 2,
            backgroundColor: 'transparent',
            borderRadius: 1,
            border: (theme) => `1px solid ${theme.palette.info.dark}`,
          }}
        >
          <Typography variant="body2" whiteSpace="break-spaces">
            This would change the category of{' '}
            <Box component="span" color={(theme) => theme.palette.info.dark}>
              <FormatQuoteRounded fontSize="small" />
              {activeReasonName}{' '}
            </Box>
            across all feedback records.
          </Typography>
        </Alert>
      )}
    </>
  );
};
